// extracted by mini-css-extract-plugin
module.exports = {"root":"AuthForm_root__3-CRJ","body":"AuthForm_body__363HC","title":"AuthForm_title__33AZ7","text":"AuthForm_text__QCmuR","buttons":"AuthForm_buttons__kByw0"};